import React from 'react';

export default function Paginator(props: {
  page: number,
  pageCount: number,
  onChange: (page: number) => void,
}) {
  const { page, pageCount, onChange } = props;
  const sizeLeft = (page - 1) < 5 ? (page - 1) : 5;
  const sizeRight = (pageCount - page) < (10 - sizeLeft) ? (pageCount - page) : (10 - sizeLeft);
  const items: React.ReactNode[] = [];
  if (page > 1) {
    items.push(<li className="previous" key="prev"><button type="button" onClick={() => { onChange(page - 1); }}>&lt;&lt;</button></li>)
  }
  for (let i = page - sizeLeft; i <= page + sizeRight; i += 1) {
    if (i === page) {
      items.push(<li className="current" key={i}><span>{i}</span></li>);
    } else {
      items.push(<li className="near" key={i}><button type="button" onClick={() => { onChange(i); }}>{i}</button></li>);
    }
  }
  if (page + sizeRight < pageCount) {
    items.push(<li className="last" key="last"><button type="button" onClick={() => { onChange(pageCount); }}>{pageCount}</button></li>);
  }
  if (page < pageCount) {
    items.push(<li className="next" key="next"><button type="button" onClick={() => { onChange(page + 1); }}>&gt;&gt;</button></li>);
  }

  return (
    <ul className="pagination" style={{ textAlign: 'center' }}>{items}</ul>
  );
}
